<template>
  <div class="app-inner">
    <el-form :inline="true">
      <el-form-item label="资产名称">
        <el-input v-model="queryInfo.assetsName" clearable placeholder="请输入资产名称"/>
      </el-form-item>
      <el-form-item label="品牌">
        <el-input v-model="queryInfo.brand" clearable placeholder="请输入品牌"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="query">查询</el-button>
        <el-button type="primary" @click="addNew('new')">新增</el-button>
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="query">
        <el-tab-pane label="所有资产" name="queryMine"></el-tab-pane>
        <!-- <el-tab-pane label="待我审批" name="queryMyAudit"></el-tab-pane> -->
        <el-tab-pane label="待领用" name="queryMyAudit">
          <div slot="label">
            待领用
                <el-badge :value='workNumber' style="margin-bottom:20px"></el-badge>
          </div>
        </el-tab-pane>
      <el-tab-pane label="领用明细" name="queryApproval"></el-tab-pane>
    </el-tabs>
    <table-list
    :loading="loading"
    :data="tableData"
    :page="page"
    :page-size="pageSize"
    :total="totalCount"
    :columnDefs="columnDefs[this.activeName]"
    @pageChange="pageChange"
    >
      <template #operate={row}>
        <!--1. 我的申请 待审核 -->
        <el-button type="text" size="small" v-if="activeName == 'queryMine'" @click="addNew('update', row.id)">编辑</el-button>
        <el-button type="text" size="small" v-if="activeName == 'queryMine'" @click="assetPurchase('details', row)">采购记录</el-button>
        <!-- 资产申领 -->
        <el-button type="text" size="small" v-if="activeName == 'queryMyAudit' || activeName == 'queryApproval'" @click="assetsclaim('details', row)">申请单详情</el-button>
        <el-button type="text" size="small" @click="RequisitionCompleted(row.id)" v-if="activeName == 'queryMyAudit'">领用完成</el-button>
      </template>
    </table-list>
    <apply-dialog ref="Apply" @addSuccess="query"/>
    <assetPurchaseTable ref="assetPurchase"/>
    <assetsclaimDialog ref="assetsclaim"/>
  </div>
</template>

<script>
import TableList from '@/components/TableList.vue'
import ApplyDialog from './applyDialog.vue'
import assetPurchaseTable from '../assetPurchase/applyTable.vue'
import assetsclaimDialog from '../assetsclaim/applyDialog.vue'
import { compAssetsInfo, compApplyAssetsReceive } from '@/api/assets.js'
import { ApprovalStatus } from '@/utils/constants'
export default {
  data () {
    return {
      ApprovalStatus: ApprovalStatus,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      workNumber: 0,
      tableData: [],
      queryInfo: {
        assetsName: '',
        brand: '',
      },
      loading: false,
      columnDefs: {
        'queryMine': [
          { label: '资产编号', prop: 'assetsNo' },
          { label: '资产名称', prop: 'assetsName' },
          { label: '品牌', prop: 'brand' },
          { label: '库存', prop: 'inventory' },
          { label: '操作', prop: 'operate', }
        ],
        'queryMyAudit': [
          { label: '申请单编号', prop: 'eventId' },
          { label: '申请人', prop: 'applyUser' },
          { label: '资产名称', prop: 'assetsName' },
          { label: '品牌', prop: 'brand' },
          { label: '领用数量', prop: 'amount' },
          { label: '申请时间', prop: 'createTime' },
          { label: '操作', prop: 'operate', }
        ],
        'queryApproval': [
          { label: '申请单编号', prop: 'eventId' },
          { label: '申请人', prop: 'applyUser' },
          { label: '资产名称', prop: 'assetsName' },
          { label: '品牌', prop: 'brand' },
          { label: '领用数量', prop: 'amount' },
          { label: '申请时间', prop: 'createTime' },
          { label: '领用时间', prop: 'receiveTime' },
          { label: '操作', prop: 'operate', }
        ],
      },
      activeName: 'queryMine'
    }
  },
  methods: {
    query () {
      this.page = 1
      this.getData()
    },
    getData () {
      this.loading = true
      let query = this.activeName === 'queryMyAudit' ? compApplyAssetsReceive : this.activeName === 'queryMine' ? compAssetsInfo : compApplyAssetsReceive
      let params = {
        ...this.queryInfo,
        pageSize: this.pageSize,
        pageNum: this.page,
      }
      if (this.activeName === 'queryMyAudit') {
        params.status = 1
        params.receiveStatus = 0
      }
      if (this.activeName === 'queryApproval') {
        params.status = 1
        params.receiveStatus = 1
      }
      query(this.activeName === 'queryMine' ? 'query' : 'queryByModel', params).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.tableData = result.records
        this.totalCount = result.total
        this.getNum()
      })
    },
    getNum() {
      let params = {
        pageNum: this.page,
        pageSize: this.pageSize,
        status: 1,
        receiveStatus: 0
      }
      compApplyAssetsReceive('queryByModel', params).then(res => {
        const { code, result } = res
        this.loading = false
        if (code !== 0) return
        this.workNumber = result.total
      })
    },
    pageChange (page) {
      this.page = page
      this.getData()
    },
    add (type = 'new', id = '') {
      this.$refs.Apply.showDetails(type, id, this.activeName)
      this.$refs.Apply.actionType = type
    },
    assetPurchase (type = 'new', item) {
      this.$refs.assetPurchase.getFixedAssetsDetails(type, item, this.activeName)
      this.$refs.assetPurchase.actionType = type
    },
    assetsclaim (type = 'new', item) {
      this.$refs.assetsclaim.getFixedAssetsDetails(type, item, 'queryMine')
      this.$refs.assetsclaim.actionType = type
    },
    update(type = 'update', id = '') {
      this.$refs.Apply.showDetails(type, id, this.activeName)
      this.$refs.Apply.actionType = 'update'
    },
    addNew (type = 'new', id = '') {
      this.$refs.Apply.showDetails(type, id, 'queryMine')
      this.$refs.Apply.actionType = 'new'
    },
    exportDetails(id) {
      this.$refs.Download.getDetails(id)
    },
    async RequisitionCompleted(id = '') {
      let params = {
          'id': id
        }
        let res = await compApplyAssetsReceive('assetsReceiveAction', params)
        if (res.code === 0) {
          this.$message({ type: 'success', message: '领用成功!' })
        }
        await this.getData()
    },
  },
  components: {
    TableList,
    ApplyDialog,
    assetPurchaseTable,
    assetsclaimDialog
  },
  mounted() {
    this.query()
  }
}
</script>
